import React from 'react';

import { type AgGridReact } from 'ag-grid-react';

import { OneOnOneDataExportsReportGrid } from './components/OneOnOneDataExportsReportGrid';

type Props = {
  gridStatePersistenceKey?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gridRef: React.RefObject<AgGridReact<any>>;
};

const OneOnOneDataExports = ({ gridStatePersistenceKey, gridRef }: Props) => (
  <OneOnOneDataExportsReportGrid gridRef={gridRef} gridStatePersistenceKey={gridStatePersistenceKey} />
);

export { OneOnOneDataExports };
